<p-toast></p-toast>
<p-progressBar mode="indeterminate" *ngIf="isLoading || processing"></p-progressBar>

<app-page-shell>

  <app-page-hero
    eyebrow="Shipments"
    title="Bulk Upload"
    subtitle="Upload, validate, correct, and process shipment workbooks.">
    <div actions>
      <p-button label="Template" icon="pi pi-download" severity="secondary" [outlined]="true" (onClick)="downloadTemplate()"></p-button>
      <p-button label="Failed Rows" icon="pi pi-file-export" severity="secondary" [outlined]="true" [disabled]="!current?.rows?.length" (onClick)="exportFailedRows()"></p-button>
      <p-button label="Process Valid Rows" icon="pi pi-check" [loading]="processing" [disabled]="!current?.batch?.validRows" (onClick)="processBatch()"></p-button>
    </div>
  </app-page-hero>

  <app-page-data-panel title="Upload File" subtitle="XLSX workbooks use Shipments and Deliveries sheets. Leave Deliveries empty for shipment-only imports.">
    <div class="upload-strip">
      <label class="file-picker">
        <i class="pi pi-upload"></i>
        <span>{{ file?.name || 'Choose XLS or XLSX file' }}</span>
        <input type="file" accept=".xlsx,.xls" (change)="onFileSelected($event)">
      </label>
      <p-button label="Upload & Validate" icon="pi pi-cloud-upload" [disabled]="!file" [loading]="isLoading" (onClick)="upload()"></p-button>
    </div>
  </app-page-data-panel>

  <app-page-metric-strip [metrics]="metrics()"></app-page-metric-strip>

  <app-page-data-panel
    title="Review Rows"
    subtitle="Correct invalid rows, then process all valid shipments and deliveries."
    [resultText]="(filteredRows.length || 0) + ' rows'">
    <div actions class="filter-actions">
      <p-select [options]="resourceOptions" [(ngModel)]="selectedResource" optionLabel="label" optionValue="value"></p-select>
      <p-select [options]="statusOptions" [(ngModel)]="selectedStatus" optionLabel="label" optionValue="value"></p-select>
    </div>

    <p-table [value]="filteredRows" dataKey="rowId" styleClass="p-datatable-gridlines" [tableStyle]="{ 'min-width': '86rem' }"
      [paginator]="true" [rows]="15" [rowsPerPageOptions]="[15, 30, 60]">
      <ng-template pTemplate="header">
        <tr>
          <th>Row</th>
          <th>Type</th>
          <th>Status</th>
          <th>Reference</th>
          <th>Details</th>
          <th>Created</th>
          <th>Error</th>
          <th class="text-right">Actions</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row>
        <tr>
          <td>{{ row.sheetName }} #{{ row.rowNumber }}</td>
          <td><strong>{{ row.resource }}</strong></td>
          <td><p-tag [value]="row.status" [severity]="statusSeverity(row.status)"></p-tag></td>
          <td>{{ rowPrimary(row) }}</td>
          <td>{{ rowSecondary(row) }}</td>
          <td>{{ row.createdEntityId || '-' }}</td>
          <td><span class="error-text">{{ row.errorMessage || '-' }}</span></td>
          <td class="text-right">
            <button pButton type="button" icon="pi pi-pencil" class="p-button-rounded p-button-text p-button-secondary mr-2" (click)="openEdit(row)"></button>
            <button pButton type="button" icon="pi pi-refresh" class="p-button-rounded p-button-text p-button-help"
              [disabled]="row.status !== 'FAILED' && row.status !== 'VALID'" (click)="retryRow(row)"></button>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr><td colspan="8"><div class="empty-state">Upload a file or open a previous batch to review rows.</div></td></tr>
      </ng-template>
    </p-table>
  </app-page-data-panel>

  <app-page-data-panel title="Import History" subtitle="Saved upload batches for this company." [resultText]="batches.length + ' batches'">
    <p-table [value]="batches" dataKey="batchId" styleClass="p-datatable-gridlines" [tableStyle]="{ 'min-width': '52rem' }"
      [paginator]="true" [rows]="8">
      <ng-template pTemplate="header">
        <tr>
          <th>File</th>
          <th>Status</th>
          <th>Rows</th>
          <th>Created</th>
          <th></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-batch>
        <tr>
          <td>
            <div class="row-type">
              <strong>{{ batch.fileName || 'Import batch ' + batch.batchId }}</strong>
              <span>{{ batch.fileType }}</span>
            </div>
          </td>
          <td><p-tag [value]="batch.status" [severity]="statusSeverity(batch.status)"></p-tag></td>
          <td>{{ batch.successRows || 0 }} success / {{ batch.failedRows || 0 }} failed / {{ batch.invalidRows || 0 }} invalid</td>
          <td>{{ batch.createdAt | date:'dd/MM/yyyy HH:mm' }}</td>
          <td class="text-right"><p-button label="Open" icon="pi pi-folder-open" severity="secondary" [outlined]="true" (onClick)="openBatch(batch)"></p-button></td>
        </tr>
      </ng-template>
    </p-table>
  </app-page-data-panel>
</app-page-shell>

<p-dialog header="Correct Import Row" [(visible)]="editDialogVisible" [modal]="true" [style]="{ width: 'min(94vw, 64rem)' }" [draggable]="false">
  <div class="edit-grid" *ngIf="editingRow">
    <label *ngFor="let column of rowColumns(editingRow)">
      <span>{{ column }}</span>
      <input pInputText [(ngModel)]="editingValues[column]">
    </label>
  </div>
  <ng-template pTemplate="footer">
    <p-button label="Cancel" icon="pi pi-times" severity="secondary" [outlined]="true" (onClick)="editDialogVisible = false"></p-button>
    <p-button label="Save & Revalidate" icon="pi pi-check" (onClick)="saveRow()"></p-button>
  </ng-template>
</p-dialog>
